export const Headers = [
  { label: "Date", largeWidth: false, alignRight: false },
  { label: "Course Name", largeWidth: false, alignRight: false },
  { label: "Learner", largeWidth: false, alignRight: false },
  { label: "Operator", largeWidth: false, alignRight: false },
  { label: "Status", largeWidth: false, alignRight: false },
];
